<script>
  import Modal from '@components/general/modal.svelte'
  import Form from '@components/forms'
  import Button from '@components/buttons/button.svelte'
  import { useForm } from '@inertiajs/svelte'
  import { CirclePlus } from 'lucide-svelte'

  let { open = $bindable(false), programmes = [] } = $props()

  const form = $derived(useForm({
    name: '',
    email_address: '',
    programme_id: '',
  }))

  function handleSubmit(e) {
    e.preventDefault()
    $form.transform((data) => {
      const payload = { ...data }
      if (!payload.programme_id) delete payload.programme_id
      return { member: payload }
    })
    $form.post('/admin/members', {
      onSuccess: () => {
        open = false
        $form.reset()
      },
    })
  }

  function handleClose() {
    $form.reset()
    $form.clearErrors()
  }

  let programmeOptions = $derived(programmes.map(p => ({ label: p.name, value: p.id })))
</script>

<Modal bind:open title="New member" onClose={handleClose}>

  <Form.Element {form} id="new-member-form" onsubmit={handleSubmit}>
    <Form.Items>
      <Form.Item name="name" label="Name" bind:value={$form.name} hint="The member's full name" cols={6} required />
      <Form.Item name="email_address" label="Email address" type="email" bind:value={$form.email_address} hint="A welcome email will be sent to this address" cols={6} required />
      <Form.Item name="programme_id" label="Programme" type="select" bind:value={$form.programme_id} options={programmeOptions} labelKey="label" valueKey="value" hint="Select a programme to grant membership access until the programme ends" cols={12} required />
    </Form.Items>
  </Form.Element>

  {#snippet footer()}
    <Button type="submit" form="new-member-form" variant="submit" loading={$form.processing} text="Create member" Icon={CirclePlus} />
  {/snippet}

</Modal>
